export const NAME = 'organization';
export const UPDATE_ORG_FORM = 'updateOrganizationForm';
export const ORGANIZATION_LOGO_FORM = 'organizationLogoForm';